import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Check } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const benefits = [
  'Exclusive legal rights to your brand name and logo',
  'Authority to take legal action against infringers',
  'Required for e-commerce brand protection programs',
  'Adds tangible value as an intellectual property asset',
  'Nationwide federal protection across all 50 states',
];

const WhyNeedSection = ({ onOpenContactForm }) => {
  const section = useScrollAnimation({ threshold: 0.1 });

  return (
    <section data-testid="why-need-section" id="why-register" ref={section.ref} className="relative overflow-hidden">
      <div className="grid lg:grid-cols-2 min-h-[600px]">
        <div className="relative bg-gradient-to-br from-[#1a0a2e] to-[#4C1D95] flex items-center order-2 lg:order-1">
          <div className="absolute inset-0 overflow-hidden">
            <div className="absolute top-20 right-20 w-[200px] h-[200px] rounded-full bg-[#14B8A6]/10 blur-[60px]" />
            <div className="absolute bottom-20 left-10 w-[150px] h-[150px] rounded-full bg-[#7C3AED]/20 blur-[50px]" />
          </div>

          <div className={`relative z-10 px-8 md:px-16 py-20 scroll-slide-left ${section.isVisible ? 'scroll-visible' : ''}`}>
            <span className="inline-block bg-[#14B8A6] text-white px-4 py-1.5 rounded-full text-xs font-bold tracking-wide mb-6">
              WHY REGISTER
            </span>
            <h2 className="text-4xl sm:text-5xl font-black tracking-tight text-white leading-tight mb-6" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
              Your Brand Deserves Federal Protection
            </h2>
            <p className="text-base text-white/60 leading-relaxed mb-8">
              Without USPTO registration, your brand has no nationwide legal protection. A registered trademark gives you exclusive ownership and the legal authority to stop infringers.
            </p>

            <ul className="space-y-3 mb-8">
              {benefits.map((b, i) => (
                <li key={i} className="flex items-start gap-3">
                  <div className="w-5 h-5 rounded-full bg-[#14B8A6]/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <Check className="w-3 h-3 text-[#14B8A6]" />
                  </div>
                  <span className="text-sm text-white/70">{b}</span>
                </li>
              ))}
            </ul>

            <Button
              data-testid="why-need-cta"
              onClick={onOpenContactForm}
              className="bg-[#14B8A6] hover:bg-[#0D9488] text-white font-semibold px-8 h-11 text-sm rounded-full active:scale-[0.97]"
            >
              Register My Trademark <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </div>
        </div>

        <div className="relative order-1 lg:order-2 min-h-[300px] lg:min-h-0">
          <img
            src="https://images.unsplash.com/photo-1631557776808-91908aba7ca0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxjb3Jwb3JhdGUlMjBsZWdhbCUyMGRvY3VtZW50cyUyMGRlc2slMjBwcm9mZXNzaW9uYWx8ZW58MHx8fHwxNzc1NTE5NjUyfDA&ixlib=rb-4.1.0&q=85"
            alt="Legal documents on professional desk"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#4C1D95]/30 to-transparent lg:bg-gradient-to-l" />
        </div>
      </div>
    </section>
  );
};

export default WhyNeedSection;
